import { useContext, useEffect, useState } from "react";
import { MainContext } from "../../../MainContext";
import AccountList from "./AccountList/AccountList";
import AddAccount from "./AddAccount/AddAccount";
import { Box } from "@mui/material";
import CollapsableBox from "../../CollapsibleBox/CollapsableBox";
import "./Account.css";

const Account = () => {
    const [showAddAcc, setShowAddAcc] = useState(false);
    const { darkMode, showGif, openState, boxOpener, texts } = useContext(MainContext);

    return (
        <div
            className="relative flex size-full min-h-screen flex-col group/design-root overflow-x-hidden"
            style={{
                fontFamily: '"Work Sans", "Noto Sans", sans-serif',
                backgroundColor: darkMode ? "black" : "white",
            }}
        >
            <div className="layout-container flex h-full grow flex-col">
                <Box>
                    <CollapsableBox title={texts.account.addAccount} isOpen={openState.addAccount} setIsOpen={() => boxOpener("addAccount")}>
                        <AddAccount setShowAddAcc={() => boxOpener("addAccount")} />
                    </CollapsableBox>
                </Box>

                <AccountList />
            </div>
        </div>
    );
};

export default Account;
